import { GetPublicRestockingListQuery } from "shared/queries/publicRestockingList/publicRestockingList.generated";

import { PublicRestockingList } from "./types";
import { serializePublicRestockingItem } from "../restockingItem/serializer";

export const serializePublicRestockingList = ({
  getPublicRestockingList: {
    publicRestockingList: { restockingItems },
  },
}: GetPublicRestockingListQuery): PublicRestockingList => ({
  restockingItems: restockingItems.map(serializePublicRestockingItem),
});
